import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../../util/pageTitles';
import Cookies from 'universal-cookie';
import Avatar from 'react-avatar';
import { withRouter } from '../../../../util/withRouter';
import { Button } from 'react-bootstrap';

import { handleError } from '../../AuthActions';
import ImageSize from '../../../../components/ImageSize/ImageSize';

import logo from '../img/logo-nave-icon.svg';

// Import Style
import '../../Auth.scss';

const cookies = new Cookies();

class CompletePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      image: '',
      email: '',
      edit: false,
    };
  }

  componentDidMount() {
    const user = cookies.get('tmpusr');
    if (user) {
      this.setState({
        email: user.email,
        name: user.name,
        image: user.image,
        edit: !user.name 
      });
    } else {
      this.setState({
        edit: true
      });
    }
  }

  continue = () => {
    if (!this.state.email) {
      this.props.handleError('Enter email address');
      return false;
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(this.state.email).toLowerCase())) {
      this.props.handleError('Invalid email');
      return false;
    }

    global.window &&
      window.location &&
      window.location.replace(
        `/api/integrations/complete?user=${encodeURIComponent(
          this.props.location.query.user
        )}&email=${encodeURIComponent(this.state.email)}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${this.props.location.query.setup ? `&setup=${this.props.location.query.setup}` : ''}${
          !!this.state.name ? `&name=${encodeURIComponent(this.state.name)}` : '' 
        }`
      );
  };

  render() {
    return (
      <div className='login_bg'>
        <Helmet>
          <title>{pageTitle('Setup account')}</title>
        </Helmet>
        <div className={`login_form single_form ${this.props.app}`}>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>Set up your Nave account</h1>
              {(this.state.image || !this.state.edit) && (
              <div className='setup_avatar_image'>
                {this.state.image ? (
                  <ImageSize src={this.state.image} alt="" />
                ) : (
                  <Avatar name={this.state.name} size={44} round="8px" maxInitials={2} />
                )}
              </div>
              )}

              <div className='form_container'>
                <label>Name</label>
                { !this.state.edit ? (<input
                  className='form-control'
                  readOnly={true}
                  value={this.state.name}
                />) : (<input
                  className='form-control'
                  autoFocus={this.state.edit}
                  onChange={e => this.setState({ name: e.target.value })}
                  value={this.state.name}
                />) }
              </div>
              <div className='form_container'>
                <label>Email</label>
                <input
                  className='form-control'
                  autoFocus={!this.state.edit}
                  onChange={e => this.setState({ email: e.target.value })}
                  value={this.state.email}
                />
              </div>
              <Button
                variant="primary"
                disabled={!this.state.email}
                onClick={this.continue}
              >
                Set up your account
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err))
  };
};

export default withRouter(connect(null, mapDispatchToProps)(CompletePage));
